import { useCallback, useState } from 'react';

import { Button, ButtonProps } from '@twilio-paste/core/button';
import { AcceptIcon } from '@twilio-paste/icons/esm/AcceptIcon';
import { CopyIcon } from '@twilio-paste/icons/esm/CopyIcon';

interface CopyButtonProps {
  title: string;
  value: string;
  disabled?: ButtonProps['disabled'];
}

export function CopyButton({ title, value, disabled }: CopyButtonProps) {
  const [showSuccessIcon, setShowSuccessIcon] = useState(false);

  const copyToClipboard = useCallback(async () => {
    await navigator.clipboard.writeText(value);
    setShowSuccessIcon(true);
    setTimeout(() => {
      setShowSuccessIcon(false);
    }, 1000);
  }, [value]);

  return (
    <Button variant="secondary" onClick={copyToClipboard} title={title} disabled={disabled}>
      {showSuccessIcon ? <AcceptIcon decorative /> : <CopyIcon decorative />}
    </Button>
  );
}
